<template>
  <table class="prop-table">
    <tr>
      <th>Количество групп</th>
      <td class="text-right">{{stat.groupAmount | getFormattedNumber}}</td>
    </tr>
    <tr>
      <th>Количество неполных групп</th>
      <td class="text-right">{{stat.incompleteGroupAmount | getFormattedNumber}}</td>
    </tr>
    <tr>
      <th>Количество игроков</th>
      <td class="text-right">{{stat.playerAmount | getFormattedNumber}}</td>
    </tr>
    <tr>
      <th>Сумма размеров всех групп</th>
      <td class="text-right">{{stat.totalGroupSize | getFormattedNumber}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'ContestRainbowStat',

  props: {
    stat: {
      type: Object,
      required: true,
    },
  },
};
</script>
